<template>
    <h5 class="text-center fw-bold">{{ label }}</h5>    
    <canvas :id="`${this.chartId}`" height="400" width="400"></canvas>    
</template>

<script>
import {Chart, LineController, CategoryScale, LinearScale, PointElement, LineElement, Filler } from "chart.js";

export default {    
    name: "SingleLineChart",    
    props: {
        chartId: {
            type: Number
        },
        label: {
            type: String,        
        },
        chartData: {
            type: Array
        },
        chartLabels: {
            type: Array
        },
        options: {
            type: Object
        }
    },
    mounted() {              
        Chart.register(LineController, CategoryScale, LinearScale, PointElement, LineElement, Filler);           
        const ctx = document.getElementById(`${this.chartId}`).getContext("2d");                             
        new Chart(ctx, {            
            type: 'line',
            data: {                
                labels: this.chartLabels,
                datasets: [{
                    label: this.label,
                    data: this.chartData,
                    fill: true,
                    borderColor: '#7DA8FF',                  
                    tension: 0.4
                }],                
            },
            options: {                                          
                scales: {
                    y: {                                                                    
                        max: Math.max.apply(Math, this.chartData) + 0.1,
                        ticks: {
                            beginAtZero: true,
                            stepSize: 1,
                            maxTicksLimit: 10,
                            callback: function(value) {
                                var moodLabels = ["Péssimo", "Ruim", "Bem", "Muito Bem", "Excelente"];
                                return moodLabels[value - 1];
                            },                            
                        },                                                                      
                    },
                    x: {
                        grid: {
                            display: false,                            
                        },
                    }
                },
                elements: {
                    point: {
                        radius: 5,                        
                    }
                },
            }          
        });                
    },
    methods: {

    }
}
</script>
